export default __webpack_public_path__ + "static/media/760.a22f4266.gif";